import numeral from 'numeral';
import 'numeral/locales/pt-br';
numeral.locale('pt-br');

export default numeral;
